<template>
  <div class="dashboard-container">
    <component :is="currentRole" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import adminDashboard from './admin'
import editorDashboard from './editor'

export default {
  name: 'Dashboard',
  components: { adminDashboard, editorDashboard },
  data() {
    return {
      currentRole: 'adminDashboard'
    }
  },
  computed: {
    ...mapGetters([
      'roles',
      'meauList',
	  'userInfo'
    ])
  },
  created() {
    if (!this.roles.includes('admin')) {
      this.currentRole = 'editorDashboard'
    }
  },
  mounted() {
	this.$api.roleUserRoleByUserId(this.userInfo.userId).then(response => {
		if(response.errcode != 0) return;
		const list = response?.data?.roleList || [];
		if(list.includes('331174919360487424') || list.includes('331174966227640320')) {
			this.$router.push({
				path: this.$store.getters["permission/getIframeMap"]('c_p_assistant_report')
			})
			window.localStorage.removeItem("routerTo");
		}
	});
  }
}
</script>
